import React from "react";

const Offers = () => {
  return (
    <div>
      <h2>About Us</h2>
      <p>Eatoor is a food delivery service that brings delicious meals to your doorstep Offers.</p>
    </div>
  );
};

export default Offers;
